export const manifest = {
  screens: {
    scr_jpy37h: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_pztwgm: { name: "About", route: "/about", position: {"x":1560,"y":220} },
    scr_wx4kfa: { name: "Services", route: "/services", position: {"x":2960,"y":220} },
    scr_wyzgar: { name: "Available Homes", route: "/homes", position: {"x":160,"y":2200} },
    scr_3p0bln: { name: "Referral Partners", route: "/referrals", position: {"x":1560,"y":2200} },
    scr_k2wknq: { name: "Contact", route: "/contact", position: {"x":4360,"y":220} },
  },
  sections: {
    sec_hqa83p: { name: "Main Navigation", x: 0, y: 0, width: 5720, height: 1180 },
    sec_4nbpy7: { name: "Property & Partnerships", x: 0, y: 1980, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_hqa83p", children: [
      { kind: "screen", id: "scr_jpy37h" },
      { kind: "screen", id: "scr_pztwgm" },
      { kind: "screen", id: "scr_wx4kfa" },
      { kind: "screen", id: "scr_k2wknq" },
    ] },
    { kind: "section", id: "sec_4nbpy7", children: [
      { kind: "screen", id: "scr_wyzgar" },
      { kind: "screen", id: "scr_3p0bln" },
    ] },
  ],
}
